<!-- Always rendered so the pointer listeners can be bound once; `is-active` is what makes it swallow input. -->
<div #overlay class="screen-lock-overlay" [class.is-active]="isLocked()" [class.is-keypad-open]="isKeypadOpen()"></div>

@if (isLocked() && isKeypadOpen()) {
  <div class="screen-lock-keypad-layer">
    <app-virtual-number-keyboard
      boundarySelector=".screen-lock-keypad-layer"
      [openAtPoint]="keypadOpenPoint()"
      [title]="lockedScreenName()"
      [subtitle]="'page.screenLock.lockedScreenHint' | translate"
      [hasError]="hasError()"
      [isVerifying]="isVerifying()"
      [showHomeButton]="true"
      (submitted)="onPinSubmitted($event)"
      (closed)="onKeypadClosed()"
      (goHome)="onGoHome()"
    />
  </div>
}
